import moment from "moment"
import { useWindowSize } from "rooks"
import { Card } from "@components/anti/Card"
import { Image } from "@components/anti/Image"
import Link from "@components/anti/Link"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact, imgUrl } from "src/mixins"

function HomeInvestors({ data, stocks, locale }) {
  const [trigger, anim] = useScrollAnim()
  const { innerWidth } = useWindowSize()
  return (
    <section className="sc-home-investors" ref={trigger}>
      <div className="py-main">
        <div className="container">
          <div className="row row-title mb-4">
            <div className="col-md-6 col-title">
              <h1 className={`title ${anim(1)}`}>{data[`title_${locale}`]}</h1>
              <div className={`description ${anim(2, "fadeInUp8")}`}>
                {convertHtmlToReact(data[`description_${locale}`])}
              </div>
            </div>
            <div className="col-md-6 d-none d-md-flex col-stocks">
              <StocksComponent
                stocks={stocks}
                className={`mt-4 ${anim(4)}`}
                locale={locale}
                anim={anim}
              />
            </div>
          </div>
          <Card
            imgRatio={innerWidth > 576 ? "r-3-1" : "r-2-1"}
            img={imgUrl(
              innerWidth > 576
                ? data?.banner_image_desktop
                : data?.banner_image_mobile
            )}
            title={data[`link_label_${locale}`]}
            variant="overlay"
            link={data?.link_url}
            className={anim(3)}
          >
            <div className="rounded-button">
              <i className="cxi-arrow-right" />
            </div>
          </Card>
          <div className="d-md-none">
            <StocksComponent
              stocks={stocks}
              className={`mt-4 ${anim(4)}`}
              locale={locale}
              anim={anim}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

function StocksComponent({ stocks, className, locale, anim }) {
  return (
    <div className={`stocks-box ${className}`}>
      <div className="stocks-info">
        <div>
          <h3 className="stocks-title">CNMA</h3>
          <p className="stocks-last-update">
            {translations[`last_update_${locale}`]}{" "}
            {moment(stocks?.fetchDate)
              .utcOffset(420)
              .format("DD/MM/YYYY (HH:mm [GMT]Z)")}
          </p>
        </div>
        <div className="d-flex flex-column align-items-end">
          <h3 className="stocks-price">
            {stocks?.currentPrice} <small>IDR</small>
          </h3>
          <div className="stocks-change">
            <div
              className={`stocks-change__item ${
                stocks?.changePercent < 0 ? "down" : "up"
              }`}
            >
              <Image
                src={`/img/icon/img_icon-change${
                  +(stocks?.changePercent || 0) < 0 ? "-down" : ""
                }.svg`}
                width={16}
                height={16}
                alt="icon-change"
              />
              <h6>{stocks?.changePercent?.toFixed(2)}%</h6>
            </div>
            <div
              className={`stocks-change__item ${
                stocks?.change < 0 ? "down" : "up"
              }`}
            >
              <Image
                src={`/img/icon/img_icon-change${
                  +(stocks?.change || 0) < 0 ? "-down" : ""
                }.svg`}
                width={16}
                height={16}
                alt="icon-change"
              />{" "}
              <h6>{stocks?.change}</h6>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <p className={anim(5, "fadeInUp7")}>
        {translations[`info_stocks_data_${locale}`]}
      </p>
    </div>
  )
}

export default HomeInvestors
